module.exports = __webpack_public_path__ + "img/profile.1544a60.svg";